import React, { useState, useEffect, useRef } from 'react';
import { Input, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLoginModal } from '@/reducers/login-pop';
import errorTip from './error-tip/errorTipManager';
import loginBgi from './assets/loginBgi.webp';
// import successfulReg from '@/assets/icons/successfulReg.webp';
import failReg from '@/assets/icons/failReg.webp';
import passwordIcon from '@/assets/icons/passwordIcon.webp';
import loginUserIcon from './assets/login-user.png';
import loginClose from '@/assets/icons/login-close.webp';
import styles from './LoginModal.module.scss';
import useRequest from '@/hooks/useRequest';
import { getSign } from '@/api/util/get-sign.js';

import { setLocalStorageExpire } from '@/libs/utils/cookie-tool.js';
import { setUID, setUserData } from '@/reducers/users';
import CryptoJS from 'crypto-js';
import Button from '@/components/button/Button';
const baseUrl = import.meta.env.VITE_AUTH;
const LoginModal = ({ onClose }) => {
  const [showModal, setShowModal] = useState(false);
  const [isVerifyLogin, setIsVerifyLogin] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [showVerifyCode, setShowVerifyCode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verifyCode, setVerifyCode] = useState(['', '', '', '', '', '']);
  const [verifyResult, setVerifyResult] = useState(null);
  const [inputAccount, setInputAccount] = useState('');
  const [inputPassword, setInputPassword] = useState('');
  const { loadingStates, sendRequest } = useRequest();
  const [countdown, setCountdown] = useState(0);
  // const [successCountdown, setSuccessCountdown] = useState(5);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [newPasswordUid, setNewPasswordUid] = useState('');
  const verifyInputRefs = useRef([]);
  const animationFrameRef = useRef(null);
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.loginPop.isLoginModalOpen);
  // const [loginData, setLoginData] = useState(null); // 添加新的状态

  let expiresTime = 60 * 24 * 30; // cookie过期时间, 单位：分钟

  useEffect(() => {
    if (isOpen) {
      animationFrameRef.current = requestAnimationFrame(() => {
        setShowModal(true);
      });
    } else {
      setShowModal(false);
      setIsVerifyLogin(false);
      setVerifyResult(null);
      setVerifyCode(['', '', '', '', '', '']);
      setShowVerifyCode(false);
      setIsForgotPassword(false);
      setPhoneNumber('');
      setInputAccount('');
      setInputPassword('');
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [isOpen]);

  // const getCurrentDateTime = () => {
  //   const now = new Date();
  //   const year = now.getFullYear();
  //   const month = String(now.getMonth() + 1).padStart(2, '0');
  //   const day = String(now.getDate()).padStart(2, '0');
  //   const hour = String(now.getHours()).padStart(2, '0');
  //   const minute = String(now.getMinutes()).padStart(2, '0');
  //   return `${year}${month}${day}${hour}${minute}`;
  // };
  const getCurrentDateTime = () => {
    // 使用服务器时间，避免客户端时间不准
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const beijingTime = new Date(utc + 3600000 * 8);
    const year = beijingTime.getFullYear();
    const month = String(beijingTime.getMonth() + 1).padStart(2, '0');
    const day = String(beijingTime.getDate()).padStart(2, '0');
    const hour = String(beijingTime.getHours()).padStart(2, '0');
    const minute = String(beijingTime.getMinutes()).padStart(2, '0');
    return `${year}${month}${day}${hour}${minute}`;
  };

  const generateMD5 = (str) => {
    return CryptoJS.MD5(str).toString();
  };

  const startCountdown = () => {
    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  const startSuccessCountdown = async (loginData) => {
    completeLoginProcess(loginData);
  };

  // 添加密码校验函数
  const validatePassword = (password, confirmPwd) => {
    if (!password) {
      setPasswordError('请输入密码');
      return false;
    }
    if (password.length < 8 || password.length > 12) {
      setPasswordError('密码长度必须在8-12位之间');
      return false;
    }
    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/.test(password)) {
      setPasswordError('密码必须包含数字和字母');
      return false;
    }
    if (confirmPwd && password !== confirmPwd) {
      setPasswordError('两次输入的密码不一致');
      return false;
    }
    setPasswordError('');
    return true;
  };
  const completeLoginProcess = async (loginData) => {
    try {
      const { uuid } = loginData;
      const loginResponse = await sendRequest(
        {
          method: 'POST',
          url: `/api/login?uuid=${uuid}`,
        },
        'loginZMUid',
      );

      if (loginResponse.status === 1) {
        setLocalStorageExpire('uid', loginResponse.data.uid, expiresTime);
        dispatch(setUID(loginResponse.data.uid));
      }

      // 发送请求userData
      const userDataForm = new FormData();
      userDataForm.append('secret', 'zmrobo');
      const loginUserData = await sendRequest({
        method: 'POST',
        url: '/api/user/getUserInfo',
        data: userDataForm,
      });

      if (loginUserData.status === 1) {
        message.success('登录成功');
        dispatch(setUserData(loginUserData.data));
        dispatch(toggleLoginModal(false));
      } else {
        throw new Error(loginUserData.message);
      }
    } catch (error) {
      console.error('登录过程中出现错误:', error);
    }
  };

  const handleVerifyCodeChange = async (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newVerifyCode = [...verifyCode];
    newVerifyCode[index] = value;
    setVerifyCode(newVerifyCode);

    // 修改这里：确保在输入一个数字后立即跳转到下一个输入框
    if (value.length === 1 && index < 5) {
      setTimeout(() => {
        verifyInputRefs.current[index + 1]?.focus();
      }, 0);
    }

    // 当所有验证码都输入完成时，自动验证
    if (index === 5 && value) {
      const fullCode = newVerifyCode.join('');
      try {
        const formData = new FormData();
        const currentTime = new Date();
        const utcDate = currentTime.getTime();
        const emailReg = new RegExp(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        );
        const valueData = emailReg.test(phoneNumber) ? 'email' : 'mobile';
        formData.append('account', phoneNumber);
        formData.append('auth_type', valueData);
        formData.append('code', fullCode);

        // 如果是找回密码流程，添加forget参数
        if (isForgotPassword) {
          const md5_one = CryptoJS.MD5('1').toString();
          formData.append('forget', md5_one);
        }

        const sign = getSign('client/verify/login', 'POST', utcDate);
        const checkCode = await sendRequest({
          method: 'POST',
          url: `${baseUrl}/client/verify/login`,
          headers: {
            'C-Date': utcDate,
            Sign: sign,
          },
          data: formData,
        });

        if (checkCode.code === 0) {
          if (isForgotPassword) {
            setVerifyResult('reset_password');
            setNewPasswordUid(checkCode.data.uuid);
          } else if (checkCode.data.passwordStatus === 0) {
            // 未设置密码，跳转到设置密码页面
            setVerifyResult('reset_password');
            setNewPasswordUid(checkCode.data.uuid);
          } else if (checkCode.data.passwordStatus === 1) {
            // 已设置密码，直接登录
            setVerifyResult('success');
            // setLoginData({ uuid: checkCode.data.uuid }); // 保存登录数据
            startSuccessCountdown({ uuid: checkCode.data.uuid });
          }
        } else {
          errorTip.error('验证码错误', 3000);
          setTimeout(() => {
            setVerifyResult('fail');
          }, 3000);
        }
      } catch (error) {
        console.error('验证码验证失败:', error);
        setVerifyResult('fail');
      }
    }
  };

  const handleVerifyCodeKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !verifyCode[index] && index > 0) {
      verifyInputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerifyCodePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, 6);
    if (!/^\d*$/.test(pastedData)) return;

    const newVerifyCode = [...verifyCode];
    for (let i = 0; i < pastedData.length; i++) {
      newVerifyCode[i] = pastedData[i];
    }
    setVerifyCode(newVerifyCode);
    // 添加以下代码：如果粘贴的是完整的6位验证码，触发验证流程
    if (pastedData.length === 6) {
      setTimeout(async () => {
        try {
          const formData = new FormData();
          const currentTime = new Date();
          const utcDate = currentTime.getTime();
          const emailReg = new RegExp(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          );
          const valueData = emailReg.test(phoneNumber) ? 'email' : 'mobile';
          formData.append('account', phoneNumber);
          formData.append('auth_type', valueData);
          formData.append('code', pastedData);

          if (isForgotPassword) {
            const md5_one = CryptoJS.MD5('1').toString();
            formData.append('forget', md5_one);
          }

          const sign = getSign('client/verify/login', 'POST', utcDate);
          const checkCode = await sendRequest({
            method: 'POST',
            url: `${baseUrl}/client/verify/login`,
            headers: {
              'C-Date': utcDate,
              Sign: sign,
            },
            data: formData,
          });

          if (checkCode.code === 0) {
            if (isForgotPassword) {
              setVerifyResult('reset_password');
              setNewPasswordUid(checkCode.data.uuid);
            } else {
              setVerifyResult('success');
              startSuccessCountdown({ uuid: checkCode.data.uuid });
            }
          } else {
            errorTip.error('验证码错误', 3000);
            setTimeout(() => {
              setVerifyResult('fail');
            }, 3000);
          }
        } catch (error) {
          console.error('验证码验证失败:', error);
          setVerifyResult('fail');
        }
      }, 0);
    }
  };

  // const onLogin = async () => {
  //   try {
  //     const emailReg = new RegExp(
  //       /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //     );
  //     const valueData = emailReg.test(inputAccount) ? 'email' : 'mobile';
  //     const regExp = new RegExp(/^[^.]*@[^.]*$/);
  //     const isStudent = regExp.test(inputAccount);

  //     if (!isStudent) {
  //       const encryptedPassword = generateMD5(inputPassword);
  //       const formData = new FormData();
  //       formData.append('account', inputAccount);
  //       formData.append('password', encryptedPassword);
  //       formData.append('auth_type', valueData);
  //       const loginResponse = await sendRequest(
  //         {
  //           method: 'POST',
  //           url: '/api/login_zm',
  //           data: formData,
  //         },
  //         'loginZMUid',
  //       );
  //       if (loginResponse.status !== 1) {
  //         errorTip.error('账号或密码错误', 3000);
  //         return;
  //       }
  //       if (loginResponse.status === 1) {
  //         setLocalStorageExpire('uid', loginResponse.data.uid, expiresTime);
  //         dispatch(setUID(loginResponse.data.uid));
  //         const userDataForm = new FormData();
  //         userDataForm.append('secret', 'zmrobo');
  //         const loginUserData = await sendRequest({
  //           method: 'POST',
  //           url: '/api/user/getUserInfo',
  //           data: userDataForm,
  //         });
  //         if (loginUserData.status === 1) {
  //           message.success('登录成功');
  //           dispatch(setUserData(loginUserData.data));
  //           dispatch(toggleLoginModal(false));
  //         } else {
  //           throw new Error(loginUserData.message);
  //         }
  //       }
  //     } else {
  //       const loginStuForm = new FormData();
  //       loginStuForm.append('account', inputAccount);
  //       const currentDateTime = getCurrentDateTime();
  //       const secretStr = `zmrobo#${currentDateTime}`;
  //       const encryptedSecret = generateMD5(secretStr);
  //       loginStuForm.append('secret', encryptedSecret);

  //       const encryptedPassword = generateMD5(inputPassword);
  //       loginStuForm.append('password', encryptedPassword);
  //       const loginStuResponse = await sendRequest(
  //         {
  //           method: 'POST',
  //           url: '/api/login_stu',
  //           data: loginStuForm,
  //         },
  //         'loginSTU',
  //       );

  //       if (loginStuResponse.status === 1) {
  //         setLocalStorageExpire('uid', loginStuResponse.data.uid, expiresTime);
  //         dispatch(setUID(loginStuResponse.data.uid));
  //         const userDataForm = new FormData();
  //         userDataForm.append('secret', 'zmrobo');
  //         const loginUserData = await sendRequest({
  //           method: 'POST',
  //           url: '/api/user/getUserInfo',
  //           data: userDataForm,
  //         });
  //         if (loginUserData.status === 1) {
  //           message.success('登录成功');
  //           dispatch(setUserData(loginUserData.data));
  //           dispatch(toggleLoginModal(false));
  //         } else {
  //           throw new Error(loginUserData.message);
  //         }
  //       } else {
  //         errorTip.error(loginStuResponse.message, 3000);
  //         return;
  //       }
  //     }
  //   } catch (error) {
  //     console.error('登录过程中出现错误:', error);
  //     return null;
  //   }
  // };

  const onLogin = async () => {
    try {
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const valueData = emailReg.test(inputAccount) ? 'email' : 'mobile';
      const isStudent = /^[^.]*@[^.]*$/.test(inputAccount);

      const loginResponse = await performLogin(isStudent, valueData); //抽离统一登录流程
      if (loginResponse.status !== 1) {
        errorTip.error(
          isStudent ? loginResponse.message : '账号或密码错误',
          3000,
        );
        return;
      }

      await handleLoginSuccess(loginResponse.data.uid);
    } catch (error) {
      console.error('登录过程中出现错误:', error);
      return null;
    }
  };

  const performLogin = async (isStudent, valueData) => {
    const encryptedPassword = generateMD5(inputPassword);

    if (!isStudent) {
      // 非学生登录
      const formData = new FormData();
      formData.append('account', inputAccount);
      formData.append('password', encryptedPassword);
      formData.append('auth_type', valueData);

      return await sendRequest(
        {
          method: 'POST',
          url: '/api/login_zm',
          data: formData,
        },
        'loginZMUid',
      );
    } else {
      // 学生登录
      const loginStuForm = new FormData();
      loginStuForm.append('account', inputAccount);
      loginStuForm.append('password', encryptedPassword);

      const currentDateTime = getCurrentDateTime();
      const secretStr = `zmrobo#${currentDateTime}`;
      const encryptedSecret = generateMD5(secretStr);
      loginStuForm.append('secret', encryptedSecret);

      return await sendRequest(
        {
          method: 'POST',
          url: '/api/login_stu',
          data: loginStuForm,
        },
        'loginSTU',
      );
    }
  };

  // 登录成功后的逻辑统一处理
  const handleLoginSuccess = async (uid) => {
    setLocalStorageExpire('uid', uid, expiresTime);
    dispatch(setUID(uid));

    // 获取用户信息
    const userDataForm = new FormData();
    userDataForm.append('secret', 'zmrobo');
    const loginUserData = await sendRequest({
      method: 'POST',
      url: '/api/user/getUserInfo',
      data: userDataForm,
    });

    if (loginUserData.status !== 1) {
      throw new Error(loginUserData.message);
    }

    message.success('登录成功');

    // await callCozeBeforeAPI(loginUserData.data);
    dispatch(setUserData(loginUserData.data));

    dispatch(toggleLoginModal(false));
  };

  // const callCozeBeforeAPI = async (userData) => {
  //   try {
  //     const currentTime = new Date();
  //     const year = currentTime.getFullYear();
  //     const month = String(currentTime.getMonth() + 1).padStart(2, '0');
  //     const day = String(currentTime.getDate()).padStart(2, '0');
  //     const hour = String(currentTime.getHours()).padStart(2, '0');
  //     const minute = String(currentTime.getMinutes()).padStart(2, '0');
  //     const timeString = `${year}${month}${day}${hour}${minute}#Zmrobo`;
  //     const secret = CryptoJS.MD5(timeString).toString();

  //     const cozeForm = new FormData();
  //     cozeForm.append('user_id', userData.uid);
  //     cozeForm.append('secret', secret);

  //     const cozeResponse = await sendRequest({
  //       method: 'POST',
  //       url: '/api/coze_before',
  //       data: cozeForm,
  //     });

  //     if (cozeResponse.status === 1 && cozeResponse.data.sso_token) {
  //       const updatedUserData = {
  //         ...userData,
  //         sso_token: cozeResponse.data.sso_token,
  //       };
  //       dispatch(setUserData(updatedUserData));
  //     } else {
  //       dispatch(setUserData(userData));
  //     }
  //   } catch (error) {
  //     dispatch(setUserData(userData));
  //   }
  // };

  const handleSendVerifyCode = async () => {
    try {
      const formData = new FormData();
      const currentTime = new Date();
      const utcDate = currentTime.getTime();
      const emailReg = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      );
      if (emailReg.test(phoneNumber)) {
        // 发送邮箱验证码
        formData.append('email', phoneNumber);
        formData.append('language', 'zh-CN');
        const sign = getSign('client/verify/mail', 'POST', utcDate);
        const sendEmail = await sendRequest(
          {
            method: 'POST',
            url: `${baseUrl}/client/verify/mail`,
            headers: {
              'C-Date': utcDate,
              Sign: sign,
            },
            data: formData,
          },
          'sendEmail',
        );

        if (sendEmail.code === 0) {
          setShowVerifyCode(true);
          // 开始倒计时
          startCountdown();
          setTimeout(() => {
            verifyInputRefs.current[0]?.focus();
          }, 0);
        } else if (sendEmail.code === -4 || sendEmail.code === -5) {
          errorTip.error('操作频繁，请稍后再试', 3000);
        } else if (sendEmail.code === -2) {
          errorTip.error('输入的邮箱有误', 3000);
        } else {
          errorTip.error(sendEmail.msg, 3000);
        }
      } else {
        // 发送手机验证码
        formData.append('mobile', phoneNumber);
        formData.append('sms_type', '86');
        const sign = getSign('client/verify/sms', 'POST', utcDate);
        const sendCode = await sendRequest(
          {
            method: 'POST',
            url: `${baseUrl}/client/verify/sms`,
            headers: {
              'C-Date': utcDate,
              Sign: sign,
            },
            data: formData,
          },
          'sendCode',
        );

        if (sendCode.code === 0) {
          setShowVerifyCode(true);
          // 开始倒计时
          startCountdown();
          setTimeout(() => {
            verifyInputRefs.current[0]?.focus();
          }, 0);
        } else if (sendCode.code === -4) {
          errorTip.error('操作频繁，请稍后再试', 3000);
        } else if (sendCode.code === -2) {
          errorTip.error('输入的手机号有误', 3000);
        } else {
          errorTip.error(sendCode.msg, 3000);
        }
      }
    } catch (error) {
      console.error('发送验证码失败:', error);
    }
  };

  const handleResetPassword = async () => {
    if (!validatePassword(newPassword, confirmPassword)) {
      return;
    }

    try {
      const formData = new FormData();
      const currentTime = new Date();
      const utcDate = currentTime.getTime();
      formData.append('uuid', newPasswordUid);
      formData.append('password', newPassword);
      const sign = getSign('client/verify/password', 'POST', utcDate);
      const newPasswordResponse = await sendRequest(
        {
          method: 'POST',
          url: `${baseUrl}/client/verify/password`,
          headers: {
            'C-Date': utcDate,
            Sign: sign,
          },
          data: formData,
        },
        'resetPassword',
      );

      if (newPasswordResponse.code === 0) {
        message.success('密码重置成功');
        // 密码重置成功，自动登录
        await completeLoginProcess({ uuid: newPasswordUid });
      } else {
        setPasswordError('密码重置失败，请重试');
      }
    } catch (error) {
      console.error('重置密码失败:', error);
      setPasswordError('密码重置失败，请重试');
    }
  };

  const renderResetPasswordForm = () => (
    <div className={styles.resetPasswordForm}>
      <div className={styles.passwordInputContainer}>
        <div className={styles.passwordIcon}>
          <img src={passwordIcon} alt="" />
        </div>
        <Input.Password
          placeholder="请再次输入密码"
          className={styles.loginInput}
          value={newPassword}
          onChange={(e) => {
            const value = e.target.value;
            setNewPassword(value);
            validatePassword(value, confirmPassword);
          }}
        />
      </div>
      <div className={styles.passwordInputContainer}>
        <div className={styles.passwordIcon}>
          <img src={passwordIcon} alt="" />
        </div>
        <Input.Password
          placeholder="请再次输入密码"
          className={styles.loginInput}
          value={confirmPassword}
          onChange={(e) => {
            const value = e.target.value;
            setConfirmPassword(value);
            validatePassword(newPassword, value);
          }}
        />
      </div>
      {passwordError && (
        <div className={styles.errorMessage}>{passwordError}</div>
      )}
      <button className={styles.loginBtn} onClick={handleResetPassword}>
        {/* 确认 */}
        {loadingStates.resetPassword ? (
          <div className={styles.buttonLoading}>
            <div className={styles.spinner} />
          </div>
        ) : (
          '确认'
        )}
      </button>
    </div>
  );
  const renderVerifyLoginForm = () => (
    <>
      {
        <div className={styles.verifyTitle}>
          <Button
            type="text-back"
            onClick={() => {
              if (verifyResult === 'reset_password') {
                setVerifyResult(null);
                setVerifyCode(['', '', '', '', '', '']);
                setShowVerifyCode(false);
                setNewPassword('');
                setConfirmPassword('');
                setPasswordError('');
                return;
              }
              if (verifyResult) {
                setVerifyResult(null);
                setVerifyCode(['', '', '', '', '', '']);
              }
              if (showVerifyCode) {
                setShowVerifyCode(false);
              } else {
                setIsVerifyLogin(false);
                setIsForgotPassword(false);
              }
            }}
          ></Button>
          <div className={styles.titleText}>
            {verifyResult === 'reset_password'
              ? '设置新密码'
              : showVerifyCode
                ? '请输入验证码'
                : isForgotPassword
                  ? '找回密码'
                  : '验证您的身份'}
          </div>
        </div>
      }
      <>
        {verifyResult === 'reset_password' ? (
          renderResetPasswordForm()
        ) : (
          <div className={styles.verifyLoginForm}>
            {!showVerifyCode ? (
              <>
                <div className={styles.phoneInputContainer}>
                  <div className={styles.userIcon}>
                    <img src={loginUserIcon} alt="" />
                  </div>
                  <Input
                    placeholder="请输入您的手机号或邮箱"
                    className={styles.phoneInput}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>

                <button
                  className={`${styles.loginBtn} ${!phoneNumber.trim() ? styles.disabled : ''}`}
                  onClick={handleSendVerifyCode}
                  disabled={!phoneNumber.trim()}
                >
                  {/* 下一步 */}
                  {loadingStates.sendEmail || loadingStates.sendCode ? (
                    <div className={styles.buttonLoading}>
                      <div className={styles.spinner} />
                    </div>
                  ) : (
                    '下一步'
                  )}
                </button>
              </>
            ) : verifyResult ? (
              <div className={styles.verifyResult}>
                <div className={styles.resultIcon}>
                  {verifyResult === 'fail' && <img src={failReg} alt="" />}
                </div>
                <div className={styles.resultText}>
                  {verifyResult === 'fail' ? '注册失败' : ''}
                </div>
                {verifyResult === 'fail' && (
                  <button
                    className={styles.loginBtn}
                    onClick={() => {
                      setVerifyResult(null);
                      setVerifyCode(['', '', '', '', '', '']);
                    }}
                  >
                    重新注册
                  </button>
                )}
              </div>
            ) : (
              // ) : verifyResult === 'fail' ? (
              //   <div className={styles.verifyResult}>
              //     <div className={styles.resultIcon}>
              //       <img src={failReg} alt="" />
              //     </div>
              //     <div className={styles.resultText}>注册失败</div>
              //     <button
              //       className={styles.loginBtn}
              //       onClick={() => {
              //         setVerifyResult(null);
              //         setVerifyCode(['', '', '', '', '', '']);
              //       }}
              //     >
              //       重新注册
              //     </button>
              //   </div>
              // ) : (
              <div className={styles.verifyCodeSection}>
                <div className={styles.verifyCodeTip}>
                  <span className={styles.phoneNumber}>{phoneNumber}</span>
                  的6位验证码
                </div>
                <div className={styles.verifyCodeInput}>
                  {verifyCode.map((code, index) => (
                    <Input
                      key={index}
                      ref={(el) => (verifyInputRefs.current[index] = el)}
                      value={code}
                      onChange={(e) =>
                        handleVerifyCodeChange(index, e.target.value)
                      }
                      onKeyDown={(e) => handleVerifyCodeKeyDown(index, e)}
                      onPaste={index === 0 ? handleVerifyCodePaste : undefined}
                      maxLength={1}
                      onFocus={() => {
                        // 如果前面的输入框为空，则将焦点设置到第一个空输入框
                        const firstEmptyIndex = verifyCode.findIndex(
                          (code) => !code,
                        );
                        if (firstEmptyIndex !== -1 && index > firstEmptyIndex) {
                          verifyInputRefs.current[firstEmptyIndex]?.focus();
                        }
                      }}
                    />
                  ))}
                </div>
                <div
                  className={`${styles.verifyCodeResend} ${countdown > 0 ? styles.disabled : ''}`}
                  onClick={() => {
                    if (countdown === 0) {
                      handleSendVerifyCode();
                    }
                  }}
                >
                  {countdown > 0
                    ? `(${countdown}s)重新发送验证码`
                    : '重新发送验证码'}
                </div>
              </div>
            )}
          </div>
        )}
      </>
    </>
  );
  const renderPasswordLoginForm = () => (
    <div style={{ padding: 40 }}>
      <div className={`${styles.phoneInputContainer}`}>
        <div className={styles.userIcon}>
          <img src={loginUserIcon} alt="" />
        </div>
        <Input
          placeholder={'请输入账号'}
          className={styles.phoneInput}
          value={inputAccount}
          onChange={(e) => setInputAccount(e.target.value)}
        />
      </div>
      <div className={styles.passwordInputContainer}>
        <div className={styles.passwordIcon}>
          <img src={passwordIcon} alt="" />
        </div>
        <Input.Password
          placeholder="密码"
          className={styles.loginInput}
          value={inputPassword}
          onChange={(e) => setInputPassword(e.target.value)}
        />
      </div>

      <button
        className={`${styles.loginBtn} ${!inputPassword.trim() || !inputAccount.trim() ? styles.disabled : ''}`}
        onClick={onLogin}
        disabled={!inputPassword.trim() || !inputAccount.trim()}
      >
        {loadingStates.loginZMUid ||
        loadingStates.loginZM ||
        loadingStates.loginSTU ? (
          <div className={styles.buttonLoading}>
            <div className={styles.spinner} />
          </div>
        ) : (
          '登录'
        )}
      </button>
      <div className={styles.loginModalFooter}>
        <span
          className={styles.footerLink}
          onClick={() => setIsVerifyLogin(true)}
        >
          验证码登录/注册
        </span>
        <span
          className={styles.footerLink}
          onClick={() => {
            setIsForgotPassword(true);
            setIsVerifyLogin(true);
          }}
        >
          找回密码
        </span>
      </div>
    </div>
  );

  if (!isOpen && !showModal) return null;

  return (
    <div
      className={`${styles.loginModalOverlay} ${showModal ? styles.show : ''}`}
    >
      <div className={styles.loginModal}>
        <div className={styles.loginModalHeader}>
          <div className={styles.loginModalClose} onClick={onClose}>
            <img src={loginClose} alt="关闭" />
          </div>
        </div>

        <div className={styles.loginModalContent}>
          <div className={styles.loginModalLogo}>
            <img src={loginBgi} alt="登录背景" />
          </div>

          <div className={styles.loginForm}>
            {isVerifyLogin
              ? renderVerifyLoginForm()
              : renderPasswordLoginForm()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
